var map = {
	"./afghanistan-flag-small.png": 7674,
	"./aland-islands-flag-small.png": 4681,
	"./albania-flag-small.png": 5540,
	"./algeria-flag-small.png": 7827,
	"./american-samoa-flag-small.png": 7956,
	"./andorra-flag-small.png": 2749,
	"./angola-flag-small.png": 8646,
	"./anguilla-flag-small.png": 9421,
	"./antigua-and-barbuda-flag-small.png": 1785,
	"./argentina-flag-small.png": 2513,
	"./armenia-flag-small.png": 8347,
	"./aruba-flag-small.png": 7723,
	"./australia-flag-small.png": 7798,
	"./austria-flag-small.png": 951,
	"./azerbaijan-flag-small.png": 6789,
	"./bahamas-flag-small.png": 1437,
	"./bahrain-flag-small.png": 4025,
	"./bangladesh-flag-small.png": 8633,
	"./barbados-flag-small.png": 3498,
	"./belarus-flag-small.png": 7160,
	"./belgium-flag-small.png": 9237,
	"./belize-flag-small.png": 7139,
	"./benin-flag-small.png": 5234,
	"./bermuda-flag-small.png": 6444,
	"./bhutan-flag-small.png": 7108,
	"./bolivia-flag-small.png": 9176,
	"./bonaire-flag-small.png": 6540,
	"./bosnia-and-herzegovina-flag-small.png": 6181,
	"./botswana-flag-small.png": 8799,
	"./brazil-flag-small.png": 6378,
	"./british-indian-ocean-territory-flag-small.png": 7597,
	"./british-virgin-islands-flag-small.png": 2492,
	"./brunei-flag-small.png": 8589,
	"./bulgaria-flag-small.png": 4853,
	"./burkina-faso-flag-small.png": 3480,
	"./burundi-flag-small.png": 7441,
	"./cambodia-flag-small.png": 7066,
	"./cameroon-flag-small.png": 5084,
	"./canada-flag-small.png": 8606,
	"./cape-verde-flag-small.png": 7060,
	"./cayman-islands-flag-small.png": 7114,
	"./central-african-republic-flag-small.png": 1575,
	"./chad-flag-small.png": 7838,
	"./chile-flag-small.png": 7549,
	"./china-flag-small.png": 8003,
	"./chrismas-island-flag-small.png": 5572,
	"./cocos-island-flag-small.png": 3941,
	"./colombia-flag-small.png": 5046,
	"./comoros-flag-small.png": 9894,
	"./congo-democratic-republic-of-the-flag-small.png": 4195,
	"./congo-republic-of-the-flag-small.png": 683,
	"./cook-island-flag-small.png": 8994,
	"./costa-rica-flag-small.png": 4690,
	"./cote-d-ivoire-flag-small.png": 9665,
	"./croatia-flag-small.png": 4397,
	"./cuba-flag-small.png": 965,
	"./curacao-flag-small.png": 9254,
	"./cyprus-flag-small.png": 6286,
	"./czech-republic-flag-small.png": 4210,
	"./denmark-flag-small.png": 4950,
	"./djibouti-flag-small.png": 8126,
	"./dominica-flag-small.png": 8770,
	"./dominican-republic-flag-small.png": 9011,
	"./east-timor-flag-small.png": 6515,
	"./ecuador-flag-small.png": 1679,
	"./egypt-flag-small.png": 467,
	"./el-salvador-flag-small.png": 7574,
	"./england-flag-small.png": 8637,
	"./equatorial-guinea-flag-small.png": 7337,
	"./eritrea-flag-small.png": 4362,
	"./estonia-flag-small.png": 8335,
	"./ethiopia-flag-small.png": 315,
	"./europe-flag-small.png": 1670,
	"./falkland-flag-small.png": 9385,
	"./faroe-islands-flag-small.png": 34,
	"./fiji-flag-small.png": 7428,
	"./finland-flag-small.png": 9376,
	"./france-flag-small.png": 631,
	"./french-polynesia.png": 4444,
	"./french-southern-antarctic-lands-flag-small.png": 8716,
	"./gabon-flag-small.png": 2939,
	"./gambia-flag-small.png": 3409,
	"./georgia-flag-small.png": 3244,
	"./germany-flag-small.png": 5533,
	"./ghana-flag-small.png": 7999,
	"./gibraltor-flag-small.png": 3342,
	"./greece-flag-small.png": 2043,
	"./greenland-flag-small.png": 3974,
	"./grenada-flag-small.png": 9110,
	"./guadeloupe-flag-small.png": 4055,
	"./guam-flag-small.png": 5978,
	"./guatemala-flag-small.png": 4949,
	"./guernsey-flag-small.png": 6470,
	"./guinea-bissau-flag-small.png": 3797,
	"./guinea-flag-small.png": 3913,
	"./guyana-flag-small.png": 575,
	"./haiti-flag-small.png": 9101,
	"./honduras-flag-small.png": 8336,
	"./hongkong-flag-small.png": 7195,
	"./hungary-flag-small.png": 6678,
	"./iceland-flag-small.png": 2466,
	"./india-flag-small.png": 5887,
	"./indonesia-flag-small.png": 9286,
	"./iran-flag-small.png": 8852,
	"./iraq-flag-small.png": 8693,
	"./ireland-flag-small.png": 2691,
	"./italy-flag-small.png": 9859,
	"./jamaica-flag-small.png": 9690,
	"./japan-flag-small.png": 9060,
	"./jordan-flag-small.png": 8898,
	"./kazakhstan-flag-small.png": 3402,
	"./kenya-flag-small.png": 6892,
	"./kiribati-flag-small.png": 2963,
	"./kosovo-flag-small.png": 6735,
	"./kuwait-flag-small.png": 6601,
	"./kyrgyzstan-flag-small.png": 1164,
	"./laos-flag-small.png": 5365,
	"./latvia-flag-small.png": 1727,
	"./lebanon-flag-small.png": 2297,
	"./lesotho-flag-small.png": 8278,
	"./liberia-flag-small.png": 3554,
	"./libya-flag-small.png": 8485,
	"./liechtenstein-flag-small.png": 3997,
	"./lithuania-flag-small.png": 379,
	"./luxembourg-flag-small.png": 7688,
	"./macau-flag-small.png": 2509,
	"./macedonia-flag-small.png": 5377,
	"./madagascar-flag-small.png": 9092,
	"./malawi-flag-small.png": 5297,
	"./malaysia-flag-small.png": 2819,
	"./maldives-flag-small.png": 7253,
	"./mali-flag-small.png": 8061,
	"./malta-flag-small.png": 94,
	"./marshall-islands-flag-small.png": 1201,
	"./mauritania-flag-small.png": 6925,
	"./mauritius-flag-small.png": 6443,
	"./mexico-flag-small.png": 2479,
	"./micronesia-flag-small.png": 916,
	"./moldova-flag-small.png": 3276,
	"./monaco-flag-small.png": 6263,
	"./mongolia-flag-small.png": 8582,
	"./montenegro-flag-small.png": 5897,
	"./morocco-flag-small.png": 6994,
	"./mozambique-flag-small.png": 8722,
	"./myanmar-flag-small.png": 5515,
	"./namibia-flag-small.png": 9553,
	"./nauru-flag-small.png": 6477,
	"./nepal-flag-small.png": 5478,
	"./netherlands-flag-small.png": 3440,
	"./new-caledonia-flag-small.png": 5945,
	"./new-zealand-flag-small.png": 8122,
	"./nicaragua-flag-small.png": 9527,
	"./niger-flag-small.png": 5321,
	"./nigeria-flag-small.png": 9323,
	"./niue-flag-small.png": 4219,
	"./north-korea-flag-small.png": 1268,
	"./northern-ireland-flag-small.png": 9076,
	"./northern-mariana-islands-flag-small.png": 2395,
	"./norway-flag-small.png": 7474,
	"./oman-flag-small.png": 5979,
	"./pakistan-flag-small.png": 435,
	"./palau-flag-small.png": 4643,
	"./palestina-flag-small.png": 2911,
	"./panama-flag-small.png": 252,
	"./papua-new-guinea-flag-small.png": 1210,
	"./paraguay-flag-small.png": 5575,
	"./peru-flag-small.png": 4262,
	"./philippines-flag-small.png": 9803,
	"./poland-flag-small.png": 6408,
	"./portugal-flag-small.png": 4434,
	"./puerto-rico-flag-small.png": 5867,
	"./qatar-flag-small.png": 9081,
	"./republic-congo-flag-small.png": 4171,
	"./romania-flag-small.png": 6059,
	"./russia-flag-small.png": 3129,
	"./rwanda-flag-small.png": 2687,
	"./saba-flag-small.png": 4793,
	"./saint-kitts-and-nevis-flag-small.png": 4549,
	"./saint-lucia-flag-small.png": 3414,
	"./saint-vincent-and-the-grenadines-flag-small.png": 5792,
	"./samoa-flag-small.png": 8131,
	"./san-marino-flag-small.png": 1957,
	"./sao-tome-and-principe-flag-small.png": 2611,
	"./saudi-arabia-flag-small.png": 8005,
	"./scotland-flag-small.png": 1136,
	"./senegal-flag-small.png": 1403,
	"./serbia-flag-small.png": 5686,
	"./seychelles-flag-small.png": 2867,
	"./sierra-leone-flag-small.png": 7418,
	"./singapore-flag-small.png": 7942,
	"./slovakia-flag-small.png": 5744,
	"./slovenia-flag-small.png": 2551,
	"./solomon-islands-flag-small.png": 4648,
	"./somalia-flag-small.png": 910,
	"./south-africa-flag-small.png": 4738,
	"./south-korea-flag-small.png": 9234,
	"./south-sudan-flag-small.png": 1627,
	"./spain-flag-small.png": 6489,
	"./sri-lanka-flag-small.png": 7382,
	"./st-eustatius-flag-small.png": 5217,
	"./st-martin-flag-small.png": 9621,
	"./sudan-flag-small.png": 2135,
	"./suriname-flag-small.png": 5698,
	"./swaziland-flag-small.png": 8645,
	"./sweden-flag-small.png": 7220,
	"./switzerland-flag-small.png": 6133,
	"./syria-flag-small.png": 6756,
	"./taiwan-flag-small.png": 5760,
	"./tajikistan-flag-small.png": 6206,
	"./tanzania-flag-small.png": 622,
	"./thailand-flag-small.png": 1667,
	"./togo-flag-small.png": 815,
	"./tokelau-flag-small.png": 7021,
	"./tonga-flag-small.png": 8681,
	"./trinidad-and-tobago-flag-small.png": 5062,
	"./tunisia-flag-small.png": 9186,
	"./turkey-flag-small.png": 9822,
	"./turkmenistan-flag-small.png": 7435,
	"./turks-caicos-islands-flag-small.png": 6269,
	"./tuvalu-flag-small.png": 1181,
	"./uganda-flag-small.png": 6228,
	"./ukraine-flag-small.png": 5145,
	"./united-arab-emirates-flag-small.png": 9849,
	"./united-kingdom-flag-small.png": 6247,
	"./united-states-of-america-flag-small.png": 7379,
	"./uruguay-flag-small.png": 6664,
	"./uzbekistan-flag-small.png": 654,
	"./vanuatu-flag-small.png": 6304,
	"./vatican-city-flag-small.png": 9532,
	"./venezuela-flag-small.png": 6435,
	"./vietnam-flag-small.png": 5188,
	"./wales-flag-small.png": 4124,
	"./yemen-flag-small.png": 7958,
	"./zambia-flag-small.png": 2008,
	"./zimbabwe-flag-small.png": 405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 281;